import Plugin from '../index.js'
import Swal from 'sweetalert2'

export default {
  fire(options = {}) {
    const theme = Plugin.$vuetify.framework.theme.isDark
      ? Plugin.$vuetify.framework.theme.themes.dark
      : Plugin.$vuetify.framework.theme.themes.light

    return Swal.fire({
      cancelButtonColor: theme.error,
      cancelButtonText: 'Abbrechen',
      confirmButtonColor: theme.primary,
      confirmButtonText: 'Ja',
      ...options
    })
  },

  fireQuestion(options = {}) {
    return this.fire({
      icon: 'question',
      showCancelButton: true,
      ...options
    })
  }
}
